export const iconFontAwesomeEditingPlus = (
	<i className="fa-solid fa-plus"></i>
);
